import { useSyncExternalStore } from 'react';
import { navigationStore } from '../../stores/navigation';
export function useUserMenuItems() {
    const subscribe = (callback) => navigationStore.subscribe(callback);
    const getSnapshot = () => navigationStore.getSnapshot().userMenuItems;
    const userMenuItems = useSyncExternalStore(subscribe, getSnapshot);
    return userMenuItems;
}
